export default "__VITE_ASSET__8d25807c__"